import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@monorepo/nova-ui';

interface Props {
  isMobile: boolean;
  productLabel: string;
}

const InvoiceTableHeader: FunctionComponent<Props> = ({
  isMobile,
  productLabel,
}) => {
  const { t } = useTranslation(['orders']);

  return (
    <TableRow>
      {!isMobile && <TableCell>{productLabel}</TableCell>}
      <TableCell>{t('orders:new_invoice_table.price_usd')}</TableCell>
      <TableCell>{t('orders:new_invoice_table.currency')}</TableCell>
      <TableCell>{t('orders:new_invoice_table.exchange_rate')}</TableCell>
      <TableCell align="right">{t('orders:new_invoice_table.price')}</TableCell>
    </TableRow>
  );
};

export default InvoiceTableHeader;
